export default __webpack_public_path__ + "static/media/maze-floor.2afaf7e0.svg";